import { h } from '@stencil/core';
import { decodeFromURI } from '@pes-ui/utils';
import { pasteScripts } from '../../../globals/utils/helpers';
export class RangePresentationTab {
  constructor() {
    this.presentation = undefined;
    this.isSlotAvailable = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderMoreFeatures() {
    if (this.presentation.presentation2) {
      return (h("div", { class: "range-presentation-tab__more-features", innerHTML: this.presentation.presentation2 }));
    }
  }
  renderArticle({ label, content = '', extraLayout = '' }) {
    if (label && (content || extraLayout)) {
      return (h("article", { class: "range-presentation-tab__article" }, h("qds-title", { class: "range-presentation-tab__article-header", layer: "main", level: "subsection", alignment: "start", variant: "web-main-section-hero" }, label), content && h("div", { class: "range-presentation-tab__article-content", innerHTML: content }), extraLayout));
    }
  }
  getWrapped(text, type) {
    switch (type) {
      case 'b':
        return `<!--BENEFITS_BEGIN-->${text}<!--BENEFITS_END-->`;
      case 'f':
        return `<!--PRESENTATION_BEGIN-->${text}<!--PRESENTATION_END-->`;
      case 'a':
        return `<!--APPLICATIONS_BEGIN-->${text}<!--APPLICATIONS_END--> `;
      default:
        return text;
    }
  }
  renderBenefits() {
    if (this.presentation.benefits) {
      return this.renderArticle({
        label: this.presentation.rangePresentationBenefitsLabel,
        content: this.getWrapped(this.presentation.benefits, 'b'),
      });
    }
  }
  renderFeatures() {
    if (this.presentation.presentation1 || this.presentation.presentation2) {
      return this.renderArticle({
        label: this.presentation.rangePresentationFeaturesLabel,
        content: this.getWrapped(this.presentation.presentation1, 'f'),
        extraLayout: this.renderMoreFeatures(),
      });
    }
  }
  renderApplications() {
    if (this.presentation.rangeApplication) {
      return this.renderArticle({
        label: this.presentation.rangePresentationApplicationsLabel,
        content: this.getWrapped(this.presentation.rangeApplication, 'a'),
      });
    }
  }
  renderGallery() {
    if (this.presentation.images && this.presentation.images.length) {
      const extraLayout = (h("ul", { class: "list-images" }, this.presentation.images.map((i) => (h("li", { class: "list-images__image-wrapper" }, h("img", { class: "list-images__image", src: i.url, alt: i.title }))))));
      return this.renderArticle({ label: this.presentation.rangeGaleryLabel, extraLayout });
    }
  }
  renderAdditionalLinks() {
    if (this.presentation.additionalLinks && this.presentation.additionalLinks.length) {
      const extraLayout = (h("div", { class: "range-presentation-tab__additional-links" }, this.presentation.additionalLinks.map((link) => (h("div", null, h("qds-standalone-link", { size: "standard", importance: "standard", href: link.url, target: link.target, class: "range-presentation-tab__additional-link" }, link.label))))));
      return this.renderArticle({
        label: this.presentation.rangeAdditionalLinksLabel,
        extraLayout,
      });
    }
  }
  componentDidRender() {
    if (this.presentation.sdlContent) {
      pasteScripts(this.el, '.overview-sdl-content');
    }
  }
  componentWillLoad() {
    const slot = this.el.querySelector('slot');
    if (!slot)
      return;
    this.isSlotAvailable = slot.assignedNodes({ flatten: true }).length > 0;
  }
  render() {
    if (this.isSlotAvailable) {
      return (h("div", { class: "overview-sdl-content range-presentation-tab__sdl-content" }, h("slot", null)));
    }
    if (this.presentation.sdlContent) {
      try {
        return (h("div", { class: "overview-sdl-content range-presentation-tab__sdl-content", innerHTML: decodeFromURI(this.presentation.sdlContent) }));
      }
      catch (error) {
        console.log(error);
      }
    }
    return (h("div", { class: "range-presentation-tab" }, h("div", null, this.renderFeatures(), this.renderBenefits(), this.renderApplications(), this.renderGallery(), this.renderAdditionalLinks())));
  }
  static get is() { return "pes-range-presentation-tab"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-presentation-tab.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-presentation-tab.css"]
    };
  }
  static get properties() {
    return {
      "presentation": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "PresentationData",
          "resolved": "{ rangePresentationFeaturesLabel?: string; presentation1?: string; presentation2?: string; rangePresentationLessFeaturesLabel?: string; rangePresentationMoreFeaturesLabel?: string; rangePresentationBenefitsLabel?: string; benefits?: string; rangePresentationApplicationsLabel?: string; rangeApplication?: string; rangeGaleryLabel?: string; images?: ImageLink[]; sdlContent?: string; additionalLinks?: any; rangeAdditionalLinksLabel?: string; }",
          "references": {
            "PresentationData": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isSlotAvailable": {}
    };
  }
  static get elementRef() { return "el"; }
}
